;(function () {
    const comps = document.querySelectorAll('.o-about-crafting');
    if (!comps.length) return;

    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
        console.warn('GSAP ou ScrollTrigger est manquant');
        return;
    }

    comps.forEach((comp) => {
        const mots = gsap.utils.toArray(comp.querySelectorAll('.o-about-crafting__mot'));
        if (!mots.length) return;

        mots.forEach((mot, index) => {
            mot.style.zIndex = index + 1;
        });

        const timeline = gsap.timeline({
            scrollTrigger: {
                trigger: comp,
                start: 'center center',
                end: `+=${mots.length * 100}%`,
                pin: true,
                scrub: 1,
                pinSpacing: true,
            },
        });

        mots.forEach((mot) => {
            timeline.to(mot, {
                opacity: 1.5,
                y: '0%',
                duration: 10,
                ease: 'power2.out',
            });
        });
    });
})();
